/**
 * Emotes (GDD §13.3): small themed pictures a player sends to the table instead of words, open to
 * every age (the chat under 14 is quick phrases and emotes). The four first are free; the others are
 * unlocked by playing (`@il-colpo/meta` has the rule of each). The pictures are drawn by the client.
 */
export const EMOTE_IDS = [
  'hat',
  'thumbsup',
  'shh',
  'sweat',
  'cigar',
  'watch',
  'glass',
  'magnifier',
] as const;

export type EmoteId = (typeof EMOTE_IDS)[number];

/** The longest an emote stays on screen, in milliseconds. */
export const EMOTE_SHOWN_MS = 4_000;
